import React, { createContext } from 'react'

export const MapContext = createContext(null)

MapContext.displayName = 'MapContext'

export const MapLayerProvider = ({ children, map }) => {
  return <MapContext.Provider value={map}>{children}</MapContext.Provider>
}
